import React from 'react'
import { getLoginUrl } from 'chemistry'

export const PraxisPlusBanner = props => {
  const { praxisPlusText, format, lang } = props
  const { title, text, loginLinkText } = praxisPlusText || {}

  const onClick = () => {
    window.location.href = getLoginUrl({ format, lang })
  }

  return (
    <div className='mxd-praxis-plus-banner gap-1 rounded'>
      <div className='mxd-praxis-plus-banner-logo flex justify-center items-center circle relative'>
        <img
          style={{ maxWidth: '64px' }}
          src='https://vdm-prd01.praxiscdn.nl/logo/PraxisPlus_Logo.svg'
          alt='Praxis plus'
        />
        <div className='mxd-praxis-plus-banner-plus absolute flex justify-center items-center circle bottom-0 right-0'>
          <img style={{ maxWidth: '12px' }} src='https://vdm-prd01.praxiscdn.nl/logo/PraxisPlus_PlusMark.svg' alt='' />
        </div>
      </div>
      <div className='flex flex-column justify-center flex-wrap gap-half'>
        <h3 className='h3'>{title}</h3>
        <div className='h4'>
          {loginLinkText && (
            <span className='mxd-praxis-plus-banner-link' onClick={onClick}>
              {loginLinkText}
            </span>
          )}
          {text && <span>{text}</span>}
        </div>
      </div>
    </div>
  )
}
